import { Outlet } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import CartDrawer from '../components/CartDrawer';

const MainLayout = () => {
  return (
    <div
      className="min-h-screen flex flex-col w-full max-w-full overflow-x-clip bg-gradient-to-b from-lumora-dark via-lumora-dark-surface to-lumora-dark"
      data-nav-bg-fallback
      data-nav-bg-gradient="#14100D,#1C1612,#14100D"
    >
      <Navbar />
      <main className="flex-1 w-full max-w-full min-w-0 overflow-x-clip">
        <Outlet />
      </main>
      <Footer />
      <CartDrawer />
    </div>
  );
};

export default MainLayout;
